<template>
    <div v-redirect-if-no-permission:SETTINGS>
        <loading-component :value="loading"/>
        <h1 style="margin: 10px;text-align: center">Settings</h1>
        <v-tabs v-model="tab" color="secondary" grow>
            <v-tabs-slider color="white"></v-tabs-slider>
            <v-tab v-for="item in ['BASIC', 'AI', 'Mobile Apps Version Management', 'Captain', 'HR Accounting']"
                   :key="item"
                   :disabled="loading">
                {{ item }}
            </v-tab>
            <v-tab-item lazy>
                <v-container>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-btn v-if="hasPermission('WAREHOUSE_REFRESH')" xs12 color="red" @click="warehouseRefresh">
                                Warehouse Refresh
                            </v-btn>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="Wassilni percentage of trips"
                                          v-model="setting.WASSILNI_PERCENTAGE"/>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="Ghost ride KM price"
                                          v-model="setting.GHOST_RIDE_KM_PRICE"/>
                        </v-flex>

                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="Difference Between Go and return trip for round trips ( in minutes )"
                                          v-model="setting.DIFFERENCE_BETWEEN_GO_AND_RETURN_IN_MINUTES"/>
                        </v-flex>

                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="MAX Working Days For Background-Checked Captains"
                                          v-model="setting.BACKGROUND_CHECKED_CAPTAIN_MAX_DAYS"/>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="MAX Rides For Background-Checked Captains"
                                          v-model="setting.BACKGROUND_CHECKED_CAPTAIN_MAX_RIDES"/>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="Max Captain Lateness to not give the passenger a penalty(In Minutes)"
                                          v-model="setting.MAX_CAPTAIN_LATENESS_IN_MINUTES_TO_GIVE_PASSENGER_PENALTY"/>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="Interview slice (interval between interviews)"
                                          v-model="setting.INTERVIEW_SLICE"/>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="Max Captains Per Interview"
                                          v-model="setting.MAX_CAPTAINS_PER_INTERVIEW"/>
                        </v-flex>
                        <v-flex xs12>
                            <v-select
                                    label="Default Whatsapp"
                                    :items="api.CONSTANTS.WHATSAPP_NUMBERS"
                                    v-model="setting.WHATSAPP_PROVIDER"
                            />
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="Successful Pooling Factor"
                                          v-model="setting.SUCCESSFUL_POOLING_FACTOR"/>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="Unsuccessful Pooling Factor"
                                          v-model="setting.UNSUCCESSFUL_POOLING_FACTOR"/>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="What's considered a long distance (per km)"
                                          v-model="setting.LONG_DISTANCE_PER_KM"/>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="Payment Limit"
                                          v-model="setting.PAYMENT_LIMIT"/>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="Land mark radius (in meters)"
                                          v-model="setting.LAND_MARK_ALLOWED_DISTANCE_IN_METERS"/>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="Penalty Time limit (in minutes)"
                                          v-model="setting.PENALTY_TIME_LIMIT_IN_MINUTES"/>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="Min Distance To place request (in meters)"
                                          v-model="setting.MIN_DISTANCE_TO_PLACE_REQUEST_IN_METERS"/>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="Captain Minimum Charge (in SP)"
                                          v-model="setting.CAPTAIN_MINIMUM_CHARGE"/>
                        </v-flex>
                        <v-flex xs12>
                            <v-textarea
                                    label="Numbers to send message to when whatsapp server is down"
                                    v-model="setting.SMS_WHEN_WHATSAPP_NOT_SEND"
                                    hint="Comma separated"
                            />
                        </v-flex>
                        <v-flex xs12>
                            <v-switch v-model="setting.ANAS_BABY_VOUCHER_GENERATOR"
                                      color="primary"
                                      label="Anas baby voucher generator"
                            />
                        </v-flex>

                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="Captain suggestion waiting time in seconds"
                                          v-model="setting.CAPTAIN_SUGGESTION_TIME_IN_SECONDS"></v-text-field>
                        </v-flex>

                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="Max set destination per day"
                                          v-model="setting.MAX_SET_DESTINATION_PER_DAY"></v-text-field>
                        </v-flex>

                        <v-flex xs12>
                            <label>Upload Id Dialog for registered after</label>
                            <v-date-picker type="date"
                                           :landscape="landscape3"
                                           label="Upload Id Dialog for registered after"
                                           v-model="setting.UPLOAD_ID_DIALOG_FOR_REGISTERED_AFTER"/>
                        </v-flex>

                    </v-layout>
                </v-container>
            </v-tab-item>

            <v-tab-item lazy>
                <v-container>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="AI User id"
                                          v-model="setting.AI_USER_ID"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-switch v-model="setting.AI_SWITCH"
                                      color="primary"
                                      label="Auto Dispatch (AI)"
                            />
                        </v-flex>
                        <v-flex xs12>
                            <v-switch v-model="setting.AI_UPDATETIME_SUGGESTION"
                                      color="primary"
                                      label="AI Suggestion (Update Time)"
                            />
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="MAX Time to dispatch (ai) in minutes"
                                          v-model="setting.MAX_TIME_TO_DISPATCH_AI_IN_MINUTES"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="AI Snooze duration(in minutes)"
                                          v-model="setting.AI_SNOOZE_DURATION_IN_MINUTES"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="AI Realtime Booking Snooze Duration (In Seconds)"
                                          v-model="setting.AI_BOOKING_SNOOZE_DURATION_IN_SECONDS"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="Min Diff Between now and creation time for ai to dispatch (In Minutes)"
                                          v-model="setting.MIN_DIFF_BETWEEN_CREATION_AND_NOW_FOR_AI_TO_DISPATCH_IN_MINUTES"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="AI Cost(Per Minute)"
                                          v-model="setting.AI_COST_PER_MINUTE"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="AI Cost (Per Km)"
                                          v-model="setting.AI_COST_PER_KM"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="AI Cost (Per Refused Booking)"
                                          v-model="setting.AI_COST_PER_REFUSED_BOOKING"></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-tab-item>

            <v-tab-item lazy>
                <v-container>
                    <v-layout row wrap>
                        <v-flex xs6 style="padding: 10px">
                            <h3>Captain App</h3>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="Captain App Last Update Version Code"
                                          v-model="setting.CAPTAIN_APP_LAST_UPDATE_VERSION_CODE"></v-text-field>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="Captain App Last Required Version Code"
                                          v-model="setting.CAPTAIN_APP_LAST_REQUIRED_VERSION_CODE"></v-text-field>
                        </v-flex>
                        <v-flex xs6 style="padding: 10px">
                            <h3>Passenger App</h3>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="Passenger App Last Update Version Code"
                                          v-model="setting.PASSENGER_APP_LAST_UPDATE_VERSION_CODE"></v-text-field>
                            <v-text-field type="number" :rules="[val => val > 0]"
                                          label="Passenger App Last Required Version Code"
                                          v-model="setting.PASSENGER_APP_LAST_REQUIRED_VERSION_CODE"></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-tab-item>

            <v-tab-item lazy>
                <v-container>
                    <v-layout row wrap>
                        <v-text-field type="number" :rules="[val => val >= 0]"
                                      label="Min Rating To Accept Suggestions"
                                      v-model="setting.MIN_RATE_TO_ACCEPT_ORDERS"/>
                        <v-text-field type="number" :rules="[val => val >= 0]"
                                      label="Min Rating To See Destination"
                                      v-model="setting.MIN_RATE_TO_SEE_DESTINATION"/>
                        <v-text-field type="number" :rules="[val => val >= 0]"
                                      label="Min Acceptance Ratio To Accept Orders"
                                      v-model="setting.MIN_ACCEPTANCE_RATIO_TO_ACCEPT_ORDERS"
                        />
                        <v-text-field type="number" :rules="[val => val >= 0]"
                                      label="Min Acceptance Ratio To See Destination"
                                      v-model="setting.MIN_ACCEPTANCE_RATIO_TO_SEE_DESTINATION"
                        />

                    </v-layout>
                </v-container>
            </v-tab-item>

            <v-tab-item lazy>
                <v-container>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <h2 class="title mb-2">General</h2>
                            <v-text-field type="number" :rules="[val => (val >= 0 && val <= 31)]"
                                          label="Number of Days Monthly"
                                          v-model="setting.NUMBER_OF_DAYS_MONTHLY"/>
                            <v-text-field type="number" :rules="[val => (val >= 0 && val <= 31)]"
                                          label="Month Starting Days"
                                          v-model="setting.MONTH_STARTING_DAY"/>
                            <v-text-field type="number" :rules="[val => (val >= 0 && val <= 31)]"
                                          label="Maximum Missed Fingerprints Monthly"
                                          v-model="setting.MAXIMUM_MISSED_FINGERPRINTS_MONTHLY"/>

                            <v-text-field type="number" :rules="[val => (val >= 0 && val <= 31)]"
                                          label="Maximum Reporting Time In Days"
                                          v-model="setting.MAXIMUM_REPORTING_TIME_IN_DAYS"/>
                            <v-spacer></v-spacer>
                            <h2 class="title mb-2">Daily Meetings:</h2>
                            <choose-time label="Start Time"
                                         v-model="setting.DAILY_MEETING_START_TIME"/>
                            <v-text-field type="number" :rules="[val => (val >= 0 && val <= 31)]"
                                          label="Max Time Of Unjustified Late Days"
                                          v-model="setting.DAILY_MEETING_MAX_TIME_OF_UNJUSTIFIED_LATE_DAYS"/>
                            <v-text-field type="number" :rules="[val => val >= 0]"
                                          label="Lateness Penalty"
                                          v-model="setting.DAILY_MEETING_LATENESS_PENALTY"/>
                            <v-spacer></v-spacer>
                            <h2 class="title mb-2">Holidays:</h2>
                            <v-text-field type="number" :rules="[val => val >= 0]"
                                          label="Sick Days Limit"
                                          v-model="setting.SICK_DAYS_LIMIT"/>
                            <v-text-field type="number" :rules="[val => val >= 0]"
                                          label="Personal Days Limit"
                                          v-model="setting.PERSONAL_DAYS_LIMIT"/>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-tab-item>
        </v-tabs>
        <v-container>
            <v-flex xs12>
                <v-layout justify-center>
                    <v-btn larget @click="save" color="primary">
                        Save
                    </v-btn>
                </v-layout>
            </v-flex>
        </v-container>
    </div>
</template>

<script>
    import LoadingComponent from "@/components/LoadingComponent";
    import ChooseTime from "@/components/wasilni/input/ChooseTime";

    export default {
        components: {ChooseTime, LoadingComponent},
        data() {
            return {
                landscape1: false,
                landscape2: false,
                landscape3: false,
                setting: {
                    MAX_SET_DESTINATION_PER_DAY: null,
                    CAPTAIN_SUGGESTION_TIME_IN_SECONDS: null,
                    INTERVIEW_SLICE: null,
                    MAX_CAPTAINS_PER_INTERVIEW: null,
                    WHATSAPP_PROVIDER: null,
                    SMS_WHEN_WHATSAPP_NOT_SEND: null,
                    SUCCESSFUL_POOLING_FACTOR: null,
                    UNSUCCESSFUL_POOLING_FACTOR: null,
                    LONG_DISTANCE_PER_KM: null,
                    PAYMENT_LIMIT: null,
                    LAND_MARK_ALLOWED_DISTANCE_IN_METERS: null,
                    PENALTY_TIME_LIMIT_IN_MINUTES: null,
                    MAX_TIME_TO_DISPATCH_AI_IN_MINUTES: null,
                    AI_USER_ID: null,
                    MIN_DISTANCE_TO_PLACE_REQUEST_IN_METERS: null,
                    AI_SWITCH: '0',
                    CAPTAIN_MINIMUM_CHARGE: null,
                    AI_SNOOZE_DURATION_IN_MINUTES: 0,
                    AI_BOOKING_SNOOZE_DURATION_IN_SECONDS: 0,
                    MIN_DIFF_BETWEEN_CREATION_AND_NOW_FOR_AI_TO_DISPATCH_IN_MINUTES: 5,
                    AI_UPDATETIME_SUGGESTION: 0,
                    UPLOAD_ID_DIALOG_FOR_REGISTERED_AFTER: null,
                    ANAS_BABY_VOUCHER_GENERATOR: 0,
                    AI_COST_PER_MINUTE: 0,
                    AI_COST_PER_KM: 0,
                    AI_COST_PER_REFUSED_BOOKING: 0,
                    BACKGROUND_CHECKED_CAPTAIN_MAX_RIDES: 0,
                    BACKGROUND_CHECKED_CAPTAIN_MAX_DAYS: 0,
                    MAX_CAPTAIN_LATENESS_IN_MINUTES_TO_GIVE_PASSENGER_PENALTY: 0,
                    CAPTAIN_APP_LAST_REQUIRED_VERSION_CODE: 0,
                    CAPTAIN_APP_LAST_UPDATE_VERSION_CODE: 0,
                    PASSENGER_APP_LAST_REQUIRED_VERSION_CODE: 0,
                    PASSENGER_APP_LAST_UPDATE_VERSION_CODE: 0,
                    DIFFERENCE_BETWEEN_GO_AND_RETURN_IN_MINUTES: 0,
                    MIN_ACCEPTANCE_RATIO_TO_ACCEPT_ORDERS: 0,
                    MIN_ACCEPTANCE_RATIO_TO_SEE_DESTINATION: 0,
                    MIN_RATE_TO_ACCEPT_ORDERS: 0,
                    MIN_RATE_TO_SEE_DESTINATION: 0,
                    BOOKING_COUNT_FOR_ACCEPTANCE_RATIO: 0,

                    DAILY_MEETING_START_TIME: null,
                    DAILY_MEETING_MAX_TIME_OF_UNJUSTIFIED_LATE_DAYS: null,
                    DAILY_MEETING_LATENESS_PENALTY: null,
                    NUMBER_OF_DAYS_MONTHLY: null,
                    MONTH_STARTING_DAY: null,
                    MAXIMUM_MISSED_FINGERPRINTS_MONTHLY: null,
                    MAXIMUM_REPORTING_TIME_IN_DAYS: null,
                    SICK_DAYS_LIMIT: null,
                    PERSONAL_DAYS_LIMIT: null
                },
                loading: false
            }
        },
        mounted() {
            this.loading = true;
            this.axios.get(
                this.api.ACTIONS.SETTINGS
            ).then(
                ({data: {data}}) => {
                    this.setting = {
                        ...data,
                        AI_SWITCH: eval(data.AI_SWITCH),
                        AI_UPDATETIME_SUGGESTION: eval(data.AI_UPDATETIME_SUGGESTION)
                    };
                    this.loading = false;
                }
            )
        },
        methods: {
            warehouseRefresh() {
                this.loading = true;
                this.axios.put('warehouse/refresh')
                    .then(() => window.getApp.$emit("SHOW_TOAST", "Done!"))
                    .catch(() => window.getApp.$emit("SHOW_TOAST", "Error!", 'red'))
                    .finally(() => this.loading = false);
            },
            save() {
                this.loading = true;
                this.axios.put(
                    this.api.ACTIONS.SETTINGS,
                    this.setting
                ).then(
                    () => window.getApp.$emit("SHOW_TOAST", "Saved!")
                ).catch(
                    ({response}) => {
                        window.getApp.$emit("SHOW_TOAST", "Problem When saving (check errorlog)", "red");
                        console.log(response);
                    }
                ).finally(
                    () => this.loading = false
                )
            }
        },
        name: "Setting",
        title: 'Setting'
    }
</script>

<style scoped>

</style>
